import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5fef6acf"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "task_text" }, " Отгадай имя: ", -1))
const _hoisted_2 = { class: "wrapper_word" }
const _hoisted_3 = { class: "letter_is_word" }

import {useStore} from 'vuex'

export default /*#__PURE__*/_defineComponent({
  __name: 'WordBlockGame',
  setup(__props) {

const store = useStore();


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(store).getters.getWord, (letter, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "wrapper_letter_is_word",
          key: index
        }, [
          _createElementVNode("p", _hoisted_3, _toDisplayString(_unref(store).getters.getRightLetters.includes(letter) ? letter : ''), 1)
        ]))
      }), 128))
    ])
  ], 64))
}
}

})